import { equals, path, pipe } from 'ramda';

import { ROLES } from 'constants/roles';

export function stopPropagation(event) {
  event.stopPropagation();
  if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();
}

export function downloadFile(data, filename) {
  if (window.navigator.appVersion.toString().indexOf('.NET') > 0)
    window.navigator.msSaveOrOpenBlob(data, filename);
  else {
    const a = document.createElement('a');
    a.setAttribute('type', 'hidden');
    a.href = window.URL.createObjectURL(new Blob([data]));
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export const debounce = func => {
  let timeoutId;
  return function (...args) {
    const context = this;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      timeoutId = null;
      func.apply(context, args)
    }, 400);
  }
};

const getServerName = path(['activeRole', 'serverName']);

export const getIsBoatManufacturer = pipe(getServerName, equals(ROLES.BOAT_MANUFACTURER.serverName));
export const getIsTrailerManufacturer = pipe(getServerName, equals(ROLES.TRAILER_MANUFACTURER.serverName));
export const getIsComponentManufacturer = pipe(getServerName, equals(ROLES.COMPONENT_MANUFACTURER.serverName));
export const getIsOilManufacturer = pipe(getServerName, equals(ROLES.OIL_MANUFACTURER.serverName));
export const getIsOilBrander = pipe(getServerName, equals(ROLES.OIL_BRANDER.serverName));



// WEBPACK FOOTER //
// ./src/app/helpers.js